// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Spice = require("@greenlabs/ppx-spice/src/rescript/Spice.bs.js");
var Js_dict = require("@rescript/std/lib/js/js_dict.js");
var Js_json = require("@rescript/std/lib/js/js_json.js");
var Nullable = require("../Nullable.bs.js");
var Type_Club = require("../club/Type_Club.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Common = require("./Type_Common.bs.js");
var Type_String = require("./Type_String.bs.js");

function t_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "lastviewed",
                    false,
                    Nullable.t_encode(Type_Club.lastviewed_encode, v.lastviewed)
                  ],
                  [
                    "season",
                    false,
                    Nullable.t_encode(Spice.intToJson, v.season)
                  ],
                  [
                    "episode",
                    false,
                    Spice.intToJson(v.episode)
                  ],
                  [
                    "totalEpisodes",
                    false,
                    Spice.intToJson(v.totalEpisodes)
                  ],
                  [
                    "url",
                    false,
                    Spice.stringToJson(v.url)
                  ]
                ]));
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var lastviewed = Nullable.t_decode(Type_Club.lastviewed_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastviewed"), null));
  if (lastviewed.TAG === /* Ok */0) {
    var season = Nullable.t_decode(Spice.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "season"), null));
    if (season.TAG === /* Ok */0) {
      var episode = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "episode"), null));
      if (episode.TAG === /* Ok */0) {
        var totalEpisodes = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "totalEpisodes"), null));
        if (totalEpisodes.TAG === /* Ok */0) {
          var url = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
          if (url.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      lastviewed: lastviewed._0,
                      season: season._0,
                      episode: episode._0,
                      totalEpisodes: totalEpisodes._0,
                      url: url._0
                    }
                  };
          }
          var e = url._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".url" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = totalEpisodes._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".totalEpisodes" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = episode._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".episode" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = season._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".season" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = lastviewed._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".lastviewed" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function data_encode(v) {
  return Spice.arrayToJson(t_encode, v);
}

function data_decode(v) {
  return Spice.arrayFromJson(t_decode, v);
}

function response_encode(v) {
  return Type_Club.$$Response.t_encode(data_encode, v);
}

function response_decode(v) {
  return Type_Club.$$Response.t_decode(data_decode, v);
}

function get(response) {
  return Belt_Array.get(Type_Club.$$Response.getData(response), 0);
}

var ApiResponse = {
  t_encode: t_encode,
  t_decode: t_decode,
  data_encode: data_encode,
  data_decode: data_decode,
  response_encode: response_encode,
  response_decode: response_decode,
  get: get
};

function t_encode$1(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "progression",
                    false,
                    Type_Common.Progression.t_encode(v.progression)
                  ],
                  [
                    "season",
                    false,
                    Spice.optionToJson(Spice.intToJson, v.season)
                  ],
                  [
                    "episode",
                    false,
                    Spice.intToJson(v.episode)
                  ],
                  [
                    "totalEpisodes",
                    false,
                    Spice.intToJson(v.totalEpisodes)
                  ],
                  [
                    "href",
                    false,
                    Type_String.Href.t_encode(v.href)
                  ]
                ]));
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var progression = Type_Common.Progression.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "progression"), null));
  if (progression.TAG === /* Ok */0) {
    var season = Spice.optionFromJson(Spice.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "season"), null));
    if (season.TAG === /* Ok */0) {
      var episode = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "episode"), null));
      if (episode.TAG === /* Ok */0) {
        var totalEpisodes = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "totalEpisodes"), null));
        if (totalEpisodes.TAG === /* Ok */0) {
          var href = Type_String.Href.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "href"), null));
          if (href.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      progression: progression._0,
                      season: season._0,
                      episode: episode._0,
                      totalEpisodes: totalEpisodes._0,
                      href: href._0
                    }
                  };
          }
          var e = href._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".href" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = totalEpisodes._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".totalEpisodes" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = episode._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".episode" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = season._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".season" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = progression._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".progression" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function make(param) {
  return {
          progression: Belt_Option.getWithDefault(Belt_Option.flatMap(Caml_option.nullable_to_opt(param.lastviewed), (function (param) {
                      var partial_arg = Caml_option.nullable_to_opt(param.timecode);
                      return Belt_Option.map(Caml_option.nullable_to_opt(param.progress), (function (param) {
                                    return Type_Common.Progression.makeFromPct(partial_arg, param);
                                  }));
                    })), Type_Common.Progression.noProgression),
          season: Caml_option.nullable_to_opt(param.season),
          episode: param.episode,
          totalEpisodes: param.totalEpisodes,
          href: Curry._1(Type_String.Href.make, param.url)
        };
}

exports.ApiResponse = ApiResponse;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.make = make;
/* Type_Club Not a pure module */
